<template>
  <div>
    <!-- 正常弹框 -->
    <div
      ref="imgModal"
      class="modal"
      :class="{ w: !pageFullScreen, 'modal-full': pageFullScreen }"
      v-if="showMask"
    >
      <div v-if="!pageFullScreen" class="modal-close" @click="hideMask"></div>
      <div ref="imgBox" class="modal-img h-full relative">
        <div
          class="modal-img-bg modal-img-bg-img h-full flex-row align-items-center"
        >
          <WebGl
            v-if="modalData.models && modalData.models[0]"
            :url="modalData.models[0].path_url"
            :pageFullScreen="pageFullScreen"
            :styleObject="styleObject"
            :fullStyleObject="fullStyleObject"
          ></WebGl>
          <div class="orthographic-content" v-else>
            <div
              class="images relative"
              v-viewer="{
                movable: false,
                loop: false,
                backdrop: 'static',
                title: false,
                toolbarOptions: {
                  prev: false,
                  next: false
                },
                navbar: false
              }"
            >
              <img :src="modalData.image_url" class="orthographic" />
              <div class="img-mask absolute pin-x pin-y"></div>
            </div>

            <div
              class="full btn cursor-pointer text-center absolute"
              @click="show"
            ></div>
          </div>
        </div>
      </div>
      <!-- <div class="modal-content"> -->
      <swiper class="modal-content" :options="swiperOption">
        <swiper-slide class="text">
          <div class="modal-content-shell cursor-default">
            <div class="modal-content-title relative">
              <i class="s-flower-light absolute"></i>{{ modalData.name }}
            </div>
            <ul class="modal-content-attribute">
              <li>烧造年代：{{ modalData.dynasty || '暂无数据' }}</li>
              <li>釉彩类别：{{ modalData.style || '暂无数据' }}</li>
              <li>瓷器用途：{{ modalData.usage || '暂无数据' }}</li>
              <li>出土区域：{{ modalData.location || '暂无数据' }}</li>
              <li>
                尺寸：
                <div class="pl-10" v-html="size(modalData)"></div>
              </li>
            </ul>
            <div class="modal-content-info">
              简介：
              <MarkdownViewer
                :emptyText="'暂无描述'"
                :content="modalData.description"
              ></MarkdownViewer>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-scrollbar" slot="scrollbar"></div>
      </swiper>
      <!-- </div> -->
      <span
        v-if="!pageFullScreen"
        class="modal-full-screen-btn cursor-pointer"
        @click="toDetail(data)"
      ></span>
      <span
        v-if="!pageFullScreen"
        :class="
          data.collection
            ? 'ceramics-content-detailed-collection active cursor-pointer'
            : 'ceramics-content-detailed-collection cursor-pointer'
        "
        @click="collection(data)"
      ></span>
    </div>
    <Masker v-if="!pageFullScreen" :show.sync="showMask"></Masker>
  </div>
</template>

<script>
import Masker from '@/components/common/Mask'
import WebGl from '../../views/porcelain/component/WebGl.vue'
import { getCeramic, getCeramicCollectWeb } from '@/core/api'
import EventBus from '@/core/eventbus'
import MarkdownViewer from '@/components/common/MarkdownViewer'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'ceramic-modal',
  components: {
    Masker,
    WebGl,
    MarkdownViewer,
    swiper,
    swiperSlide
  },
  props: {
    data: null,
    pageFullScreen: null
  },
  data() {
    return {
      showMask: false,
      modalData: {},
      styleObject: null,
      fullStyleObject: null,
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        mousewheel: true
      }
    }
  },
  computed: {
    isLogin() {
      let subscriber = this.$store.getters['SubscriberStore/subscriber']
      let client = this.$store.getters['SubscriberStore/client']
      return subscriber && client && subscriber.open_id && client.mobile
    }
  },
  watch: {
    data() {
      if (!this.data) {
        return
      }
      let mode = this.$route.hash ? this.$route.hash : 'production'
      if (this.data.models && mode !== '#debug') {
        this.openModal(this.data)
      } else {
        this.getCeramicInfo(this.data.id)
      }
    },
    showMask(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.pageFullScreen && this.$refs) {
            if (this.$refs.imgBox) {
              this.styleObject = {
                width: this.$refs.imgBox.offsetWidth + 'px',
                height: this.$refs.imgBox.offsetHeight + 'px'
              }
            }
            if (this.$refs.imgModal) {
              this.fullStyleObject = {
                width: this.$refs.imgModal.offsetWidth + 'px',
                height: this.$refs.imgModal.offsetHeight + 'px'
              }
            }
          }
          // eslint-disable-next-line no-console
          console.log(this.styleObject, this.fullStyleObject)
        })
      }
    }
  },
  mounted() {},
  methods: {
    size(item) {
      if (
        !item.caliber &&
        !item.abdomen_diameter &&
        !item.foot_diameter &&
        !item.bottom_diameter &&
        !item.height &&
        !item.length &&
        !item.width &&
        (!item.first_bottom || !item.second_bottom)
      ) {
        return '暂无尺寸信息'
      }
      let arr = []
      if (item.caliber) {
        arr.push(`口径：${item.caliber}cm`)
      }
      if (item.abdomen_diameter) {
        arr.push(`腹径：${item.abdomen_diameter}cm`)
      }
      if (item.foot_diameter) {
        arr.push(`足径：${item.foot_diameter}cm`)
      }
      if (item.bottom_diameter) {
        arr.push(`底径：${item.bottom_diameter}cm`)
      }
      if (item.height) {
        arr.push(`高度：${item.height}cm`)
      }
      if (item.length) {
        arr.push(`长度：${item.length}cm`)
      }
      if (item.width) {
        arr.push(`宽度：${item.width}cm`)
      }
      if (item.first_bottom && item.second_bottom) {
        arr.push(`底足：${item.first_bottom}cm × ${item.second_bottom}cm`)
      }

      return arr.join('<br/>')
    },
    //展品收藏
    async collection(list) {
      if (!this.isLogin) {
        // 没登陆时，弹出登陆弹框
        EventBus.$emit('showModal')
        this.showMask = false
        return
      }
      let res = await getCeramicCollectWeb(list.uuid)
      if (res.status === 200) {
        this.$store.dispatch('SubscriberStore/fetch') // 获取个人信息
        this.$swal({
          position: 'top-end',
          type: 'success',
          toast: true,
          text: res.data,
          showConfirmButton: false,
          timer: 3000
        })
        this.data.collection = !this.data.collection
      }
    },
    toDetail(data) {
      let routeUrl = this.$router.resolve({
        path: `/ceramic/${data.uuid}`
      })
      window.open(routeUrl.href)
    },
    show() {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    },
    // 隐藏弹窗及遮罩层 （type的值：'modal'不全屏的弹框; 'modalFull'全屏的弹框）
    hideMask() {
      this.showMask = false
      this.$parent.modalData = null
    },
    // 弹出modal
    openModal(list) {
      this.modalData = list
      this.showMask = true
    },
    // 拿到瓷器详情
    async getCeramicInfo(id) {
      let res = await getCeramic(id)
      // // eslint-disable-next-line no-console
      // console.log(res)
      if (res.status === 200) {
        this.$set(this, 'modalData', res.data)
        this.showMask = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
// 弹出框
.modal,
.modal-full-screen {
  position: fixed;
  z-index: 9;
  .modal-img {
    float: left;
    width: 70%;
    .modal-img-bg-img {
      justify-content: space-around;
      background-color: #000;
      background-position: center, center;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
  }
  .modal-btns {
    cursor: pointer;
    position: absolute;
    bottom: 20px;
    right: 17px;
    img {
      width: 25px;
      height: 25px;
    }
  }
  .modal-btn-text {
    height: 20px;
    line-height: 20px;
    background-color: $c-5b4a39;
    opacity: 0.8;
    padding: 0 7px;
    color: $c-white;
    font-family: $f-STKaiti;
    font-size: 12px;
    border-radius: 4px;
    margin-bottom: 5px;
  }

  .modal-content {
    float: left;
    width: 30%;
    padding-bottom: 54px;
    max-height: 700px;
    height: 100%;
    // overflow-y: auto;
  }
  .modal-content-shell {
    padding: 88px 30px 54px 60px;
    color: $c-white;
    .s-flower-light {
      top: 4px;
      left: -48px;
    }
  }
  .modal-content-title {
    text-align: left;
    font-size: 28px;
    line-height: 1.04;
    padding-bottom: 20px;
  }
  .modal-content-attribute,
  .modal-content-info {
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }
  .modal-content-info {
    padding: 10px 0;
    // overflow-x: hidden;
    // > div {
    //   overflow: hidden;
    //   -o-text-overflow: ellipsis; /* Opera 9-10 */
    //   text-overflow: ellipsis;
    //   display: -webkit-box;
    //   -webkit-line-clamp: 5;
    //   -webkit-box-orient: vertical;
    // }
  }
}

.modal,
.modal-full {
  background-color: $c-tour-0;
  position: fixed;
}
.modal {
  height: 700px;
  left: 50%;
  top: 50%;
  margin-top: -350px;
  margin-left: -600px;
}
.modal-full {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  margin-top: 0;
  margin-left: 0;
}
.orthographic-content {
  width: 500px;
  height: 400px;
}
.images {
  width: 100%;
  height: 100%;
  .img-mask {
    background-color: $c-transparent;
  }
}

.orthographic {
  top: 50%;
  transform: translateY(-50%);
  position: relative;
  height: 100%;
  width: auto;
}
.full {
  background-image: url('../../../static/images/porcelain/icon-btn.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.btn {
  width: 25px;
  height: 25px;
  line-height: 25px;
  bottom: 15px;
  right: 15px;
}
.btn:hover {
  background-color: rgba(0, 0, 0, 0.3);
  border: none;
}

.modal-full-screen-btn,
.ceramics-content-detailed-collection {
  z-index: 2;
  width: 36px;
  height: 32px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 0 center;
  position: absolute;
  bottom: 22px;
}

.ceramics-content-detailed-collection {
  background-image: url('../../../static/images/ceramic/collection.png');
  right: 20px;
  &:hover {
    transition: 0.35s;
    background-image: url('../../../static/images/ceramic/collection-hover.png');
  }
  &.active {
    transition: 0.35s;
    background-image: url('../../../static/images/ceramic/collected.png');
  }
}
.modal-full-screen-btn {
  background-image: url('../../../static/images/porcelain/info.png');
  right: 76px;
}

.swiper-slide.text {
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
